import axios from "axios";
import {
  PermissionResponse,
  GroupedPermission,
  Privilege,
} from "../types/Permission";
import { AppAccessRoleType } from "../types/role";
import { groupPrivilegesByType } from "../utils/permission";

export async function getAllPermission(): Promise<GroupedPermission> {
  const res = await axios.request<PermissionResponse>({
    url: "/sherpa/v0/api/roles/privileges",
    method: "GET",
  });
  const grouped = groupPrivilegesByType(res.data.data.group);
  return grouped;
}

export async function getRolePermission(
  role: string
): Promise<GroupedPermission> {
  const res = await axios.request<PermissionResponse>({
    url: `/sherpa/v0/api/roles/${role}`,
    method: "GET",
  });
  const grouped = groupPrivilegesByType(res.data.data.group);
  return grouped;
}

export async function patchRolePermission(
  role: AppAccessRoleType,
  data: { privileges: Omit<Privilege, "name">[] }
): Promise<GroupedPermission> {
  const res = await axios.request({
    url: `/sherpa/v0/api/roles/${role}`,
    method: "PATCH",
    data,
  });
  return res.data;
}

export async function createRolePermission(data: {
  privileges: Omit<Privilege, "name">[];
  name: string;
}): Promise<GroupedPermission> {
  const res = await axios.request({
    url: `/sherpa/v0/api/roles`,
    method: "POST",
    data,
  });
  return res.data;
}

// Generated by https://quicktype.io

export interface ClientRolesResponse {
  data: ClientRole[];
}

export interface ClientRole {
  slug: string;
  name: string;
}

export async function getRoles() {
  const resp = await axios.get<ClientRolesResponse>("/sherpa/v0/api/roles");
  return resp.data;
}

export async function getAllRoles() {
  const resp = await axios.get<ClientRolesResponse>("/sherpa/v0/api/roles/all");
  return resp.data;
}
